(() => {
  const element = document.getElementById('SNFSpecialtyCartConfig');
  if (!element || window.SNFSpecialtyCart) return;
  const config = JSON.parse(element.textContent);
  const ids = new Set(config.productIds.map(String));
  const denominations = Object.entries(config.components).map(([cents, id]) => ({ cents: Number(cents), id: Number(id) })).sort((a, b) => b.cents - a.cents);
  const componentIds = new Set(denominations.map(item => String(item.id)));
  const url = path => (window.Shopify?.routes?.root || '/') + path;
  const calculate = (width, height, quantity) => {
    if (![width, height, quantity].every(Number.isFinite) || width < 1 || width > 18 || height < 1 || height > 50 || !Number.isInteger(width * 2) || !Number.isInteger(height * 2) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error(config.invalid);
    const rateCents = quantity >= 50 ? 20 : quantity >= 25 ? 24 : quantity >= 10 ? 32 : 40;
    const eachCents = Math.round(width * height * rateCents);
    const totalCents = eachCents * quantity;
    if (!Number.isSafeInteger(totalCents)) throw new Error(config.invalid);
    return { width, height, quantity, rateCents, eachCents, totalCents };
  };
  const components = cents => {
    if (!Number.isSafeInteger(cents) || cents < 0) throw new Error(config.mismatch);
    let remaining = cents;
    return denominations.map(item => {
      const quantity = Math.floor(remaining / item.cents);
      remaining -= quantity * item.cents;
      return { id: item.id, quantity };
    }).filter(item => item.quantity > 0);
  };
  const request = async (path, body) => {
    const response = await fetch(url(path), {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || config.failed);
    return result;
  };
  const verify = cart => {
    if (cart.currency !== 'CAD') throw new Error(config.currency);
    const items = cart.items || [];
    const mains = items.filter(item => ids.has(String(item.product_id)));
    const seen = new Set();
    for (const main of mains) {
      const props = main.properties || {};
      const group = props._snf_specialty_group;
      if (!group || props._snf_specialty_role !== 'main' || seen.has(group)) throw new Error(config.mismatch);
      seen.add(group);
      const expected = calculate(Number(props._snf_width), Number(props._snf_height), main.quantity);
      if (Number(props._snf_pieces) !== main.quantity || Number(props._snf_total) !== expected.totalCents) throw new Error(config.mismatch);
      if (!Object.entries(props).some(([key, value]) => key.includes('Special Effect Prints') && !key.startsWith('_') && /^https:\/\//i.test(String(value)))) throw new Error(config.artwork);
      const children = items.filter(item => componentIds.has(String(item.variant_id)) && item.properties?._snf_specialty_group === group);
      const base = Number(main.original_price ?? main.price) * main.quantity;
      const expectedComponents = components(expected.totalCents - base);
      if (children.length !== expectedComponents.length) throw new Error(config.mismatch);
      for (const part of expectedComponents) {
        const child = children.find(item => String(item.variant_id) === String(part.id));
        if (!child || child.quantity !== part.quantity || child.properties?._snf_specialty_role !== 'component' || child.parent_relationship?.parent_key !== main.key) throw new Error(config.mismatch);
      }
      const total = base + children.reduce((sum, item) => sum + Number(item.original_price ?? item.price) * item.quantity, 0);
      if (total !== expected.totalCents) throw new Error(config.mismatch);
    }
    if (items.some(item => componentIds.has(String(item.variant_id)) && !seen.has(item.properties?._snf_specialty_group))) throw new Error(config.mismatch);
    return true;
  };
  const removeGroup = async group => {
    const cart = await request('cart.js');
    const updates = {};
    cart.items.filter(item => item.properties?._snf_specialty_group === group && (ids.has(String(item.product_id)) || componentIds.has(String(item.variant_id)))).forEach(item => { updates[item.key] = 0; });
    return Object.keys(updates).length ? request('cart/update.js', { updates }) : cart;
  };
  const verifyCheckout = async cart => {
    if (!(cart.items || []).some(item => ids.has(String(item.product_id)) || componentIds.has(String(item.variant_id)))) return true;
    try { return verify(cart); } catch (error) { window.alert(error.message); return false; }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-snf-specialty-remove]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.disabled = true;
    try { await removeGroup(button.dataset.snfSpecialtyRemove); window.location.reload(); }
    catch (error) { window.alert(error.message); button.disabled = false; }
  }, true);
  window.SNFSpecialtyCart = { calculate, components, request, verify, verifyCheckout, removeGroup, config };
})();
